/* eslint-disable max-len */
export const SR_QUEUE_JOB_UPDATE_LISTING = 'SR_QUEUE_JOB_UPDATE_LISTING';
export const SR_QUEUE_JOB_FRONT_TEXT_FROM_CUSTOMER_TEXTS_INBOX =
  'SR_QUEUE_JOB_FRONT_TEXT_FROM_CUSTOMER_TEXTS_INBOX'; // eslint-disable-line max-len
export const SR_QUEUE_JOB_UPSERT_SMART_APARTMENT_BY_ID =
  'SR_QUEUE_JOB_UPSERT_SMART_APARTMENT_BY_ID';
export const SR_QUEUE_JOB_SLACK_MESSAGE = 'SR_QUEUE_JOB_SLACK_MESSAGE';
export const SR_QUEUE_JOB_SLACK_MESSAGES = 'SR_QUEUE_JOB_SLACK_MESSAGES';
export const SR_QUEUE_JOB_ASSIGN_LEAD_APARTMENT_LOCATOR =
  'SR_QUEUE_JOB_ASSIGN_LEAD_APARTMENT_LOCATOR';
export const SR_QUEUE_JOB_TOUR_CONFIRMATION_AUTOTEXT = 'SR_QUEUE_JOB_TOUR_CONFIRMATION_AUTOTEXT';
export const SR_QUEUE_JOB_PUSH_NOTIFICATION = 'SR_QUEUE_JOB_PUSH_NOTIFICATION';
export const SR_QUEUE_JOB_LISTING_NOT_AVAILABLE_MESSAGING =
  'SR_QUEUE_JOB_LISTING_NOT_AVAILABLE_MESSAGING'; // eslint-disable-line max-len
export const SR_QUEUE_JOB_GENERATE_SUNROOM_LISTING_PHOTOS =
  'SR_QUEUE_JOB_GENERATE_SUNROOM_LISTING_PHOTOS';
export const SR_QUEUE_JOB_TWILIO_TEXT = 'SR_QUEUE_JOB_TWILIO_TEXT';
export const SR_QUEUE_JOB_SENDGRID_EMAIL = 'SR_QUEUE_JOB_SENDGRID_EMAIL';
export const SR_QUEUE_JOB_HANDLE_POST_SIGNUP = 'SR_QUEUE_JOB_HANDLE_POST_SIGNUP';
export const SR_QUEUE_JOB_HANDLE_POST_REQUEST_SHOWING = 'SR_QUEUE_JOB_HANDLE_POST_REQUEST_SHOWING';
export const SR_QUEUE_JOB_UPDATE_TOUR_TO_COMPLETED = 'SR_QUEUE_JOB_UPDATE_TOUR_TO_COMPLETED';
export const SR_QUEUE_JOB_AUTO_ASSIGN_TOUR_GUIDE = 'SR_QUEUE_JOB_AUTO_ASSIGN_TOUR_GUIDE';
export const SR_QUEUE_JOB_CHECK_SR_MLS_LISTING_FIELDS_MISMATCH =
  'SR_QUEUE_JOB_CHECK_SR_MLS_LISTING_FIELDS_MISMATCH'; // eslint-disable-line max-len
export const SR_QUEUE_JOB_SYNC_TENANT_ALERT_REPORT = 'SR_QUEUE_JOB_SYNC_TENANT_ALERT_REPORT';
export const SR_QUEUE_JOB_SEND_NPS_RATING_MESSAGES = 'SR_QUEUE_JOB_SEND_NPS_RATING_MESSAGES';
export const SR_QUEUE_JOB_ASSIGN_RENTLINX_LEAD_TO_APARTMENT_LOCATOR =
  'SR_QUEUE_JOB_ASSIGN_RENTLINX_LEAD_TO_APARTMENT_LOCATOR'; // eslint-disable-line max-len
export const SR_QUEUE_JOB_API_ACTION = 'SR_QUEUE_JOB_API_ACTION';
export const SR_QUEUE_JOB_SEND_LOCATOR_TOUR_FEEDBACK_NOTIFICATIONS =
  'SR_QUEUE_JOB_SEND_LOCATOR_TOUR_FEEDBACK_NOTIFICATIONS'; // eslint-disable-line max-len
export const SR_QUEUE_JOB_REFRESH_CUSTOMER_IO_LISTINGS_COLLECTION =
  'SR_QUEUE_JOB_REFRESH_CUSTOMER_IO_LISTINGS_COLLECTION'; // eslint-disable-line max-len
export const SR_QUEUE_JOB_TRACK_3D_TOUR_CLOSED = 'SR_QUEUE_JOB_TRACK_3D_TOUR_CLOSED';
export const SR_QUEUE_JOB_GENERATE_TENANT_ALERT_REPORT_PDF =
  'SR_QUEUE_JOB_GENERATE_TENANT_ALERT_REPORT_PDF';
export const SR_QUEUE_JOB_PARTNER_PROMISE_DATE_UPDATED_ALERT =
  'SR_QUEUE_JOB_PARTNER_PROMISE_DATE_UPDATED_ALERT'; // eslint-disable-line max-len
export const SR_QUEUE_JOB_LISTING_ACTIVE_RENTER_EMAILS =
  'SR_QUEUE_JOB_LISTING_ACTIVE_RENTER_EMAILS';
export const SR_QUEUE_JOB_LISTING_PRICE_REDUCED_ALERT = 'SR_QUEUE_JOB_LISTING_PRICE_REDUCED_ALERT';
export const SR_QUEUE_JOB_LISTING_CONCESSION_CREATED_ALERT =
  'SR_QUEUE_JOB_LISTING_CONCESSION_CREATED_ALERT';
export const SR_QUEUE_JOB_ACH_PAYMENT_BALANCE_CHECK = 'SR_QUEUE_JOB_ACH_PAYMENT_BALANCE_CHECK';
export const SR_QUEUE_JOB_TRANSFER_SECURITY_DEPOSIT = 'SR_QUEUE_JOB_TRANSFER_SECURITY_DEPOSIT';
export const SR_QUEUE_JOB_GENERATE_WATERMARKED_PHOTOS = 'SR_QUEUE_JOB_GENERATE_WATERMARKED_PHOTOS';
export const SR_QUEUE_JOB_GENERATE_CONCESSION_WATERMARKED_PHOTOS =
  'SR_QUEUE_JOB_GENERATE_CONCESSION_WATERMARKED_PHOTOS'; // eslint-disable-line max-len
export const SR_QUEUE_JOB_CREATE_FIX_ORDER = 'SR_QUEUE_JOB_CREATE_FIX_ORDER';
export const SR_QUEUE_JOB_ROUTABLE_INVOICE = 'SR_QUEUE_JOB_ROUTABLE_INVOICE';
export const SR_QUEUE_JOB_GENERATE_RENTER_APP_ADDITIONAL_QUESTIONS =
  'SR_QUEUE_JOB_GENERATE_RENTER_APP_ADDITIONAL_QUESTIONS'; // eslint-disable-line max-len
export const SR_QUEUE_JOB_CREDIT_SCORE_NOT_QUALIFIED_ALERT =
  'SR_QUEUE_JOB_CREDIT_SCORE_NOT_QUALIFIED_ALERT';
export const SR_QUEUE_JOB_ROUTABLE_HANDLE_INVOICE_UPDATE =
  'SR_QUEUE_JOB_ROUTABLE_HANDLE_INVOICE_UPDATE';
export const SR_QUEUE_JOB_REFRESH_MATERIALIZED_DB_VIEWS =
  'SR_QUEUE_JOB_REFRESH_MATERIALIZED_DB_VIEWS';
export const SR_QUEUE_JOB_APP_READY_FOR_REVIEW = 'SR_QUEUE_JOB_APP_READY_FOR_REVIEW';
export const SR_QUEUE_JOB_PROCESS_STATUS_UPDATE = 'SR_QUEUE_JOB_PROCESS_STATUS_UPDATE';
export const SR_QUEUE_JOB_PROCESS_UTILITY_PARTNER_STATUS_CHANGE =
  'SR_QUEUE_JOB_PROCESS_UTILITY_PARTNER_STATUS_CHANGE';
export const SR_QUEUE_JOB_ALGOLIA_ADD_PARTNER_ADDRESS = 'SR_QUEUE_JOB_ALGOLIA_ADD_PARTNER_ADDRESS';
export const SR_QUEUE_JOB_ALGOLIA_REMOVE_PARTNER_ADDRESS =
  'SR_QUEUE_JOB_ALGOLIA_REMOVE_PARTNER_ADDRESS';
export const SR_QUEUE_JOB_UTILITY_SLACK_SEND_MESSAGE = 'SR_QUEUE_JOB_UTILITY_SLACK_SEND_MESSAGE';
export const SR_QUEUE_JOB_UTILITY_SLACK_REMOVE_MESSAGE =
  'SR_QUEUE_JOB_UTILITY_SLACK_REMOVE_MESSAGE';

export const SR_QUEUE_JOB_FRONT_AUTO_TEXT = 'SR_QUEUE_JOB_FRONT_AUTO_TEXT';
export const SR_QUEUE_JOB_FRONT_TEXT = 'SR_QUEUE_JOB_FRONT_TEXT';
export const SR_QUEUE_JOB_FRONT_COMMENT = 'SR_QUEUE_JOB_FRONT_COMMENT';
export const SR_QUEUE_JOB_FRONT_TAGS = 'SR_QUEUE_JOB_FRONT_TAGS';
export const SR_QUEUE_JOB_FRONT_CREATE_CONTACT_NOTE = 'SR_QUEUE_JOB_FRONT_CREATE_CONTACT_NOTE';
export const SR_QUEUE_JOB_FRONT_UPDATE_CONVERSATION = 'SR_QUEUE_JOB_FRONT_UPDATE_CONVERSATION';
export const SR_QUEUE_JOB_FRONT_WEBHOOKS_PROCESS_MESSAGE =
  'SR_QUEUE_JOB_FRONT_WEBHOOKS_PROCESS_MESSAGE';

export const SR_QUEUE_JOB_PROCESS_MANUAL_GMAIL_SENDER_MAPPING =
  'SR_QUEUE_JOB_PROCESS_MANUAL_GMAIL_SENDER_MAPPING';
export const SR_QUEUE_JOB_FRONT_UTILITY_TEXT = 'SR_QUEUE_JOB_FRONT_UTILITY_TEXT';
export const SR_QUEUE_JOB_PROCESS_LOG_GROUP_ADDRESS_STATUSES =
  'SR_QUEUE_JOB_PROCESS_LOG_GROUP_ADDRESS_STATUSES';
export const SR_QUEUE_JOB_FCC_SCRAPE_ADDRESS = 'SR_QUEUE_JOB_FCC_SCRAPE_ADDRESS';
export const SR_QUEUE_JOB_INGEST_SERVICE_AREAS = 'SR_QUEUE_JOB_INGEST_SERVICE_AREAS';

export const SR_QUEUE_JOB_SCRAPE_DEALER_PORTAL_PROVIDER_INTERNET_PLANS =
  'SR_QUEUE_JOB_SCRAPE_DEALER_PORTAL_PROVIDER_INTERNET_PLANS';
export const SR_QUEUE_JOB_SCRAPE_DEALER_PORTAL_PERFECT_VISION_PROVIDER_INTERNET_PLANS =
  'SR_QUEUE_JOB_SCRAPE_DEALER_PORTAL_PROVIDER_INTERNET_PLANS_PERFECT_VISION';
export const SR_QUEUE_JOB_SCRAPE_DEALER_PORTAL_PERFECT_VISION_PROVIDER_INTERNET_PLANS_CONCURRENCY = 5;
export const SR_QUEUE_JOB_SCRAPE_DEALER_PORTAL_IBEX_PROVIDER_INTERNET_PLANS =
  'SR_QUEUE_JOB_SCRAPE_DEALER_PORTAL_IBEX_PROVIDER_INTERNET_PLANS';
export const SR_QUEUE_JOB_SCRAPE_DEALER_PORTAL_IBEX_PROVIDER_INTERNET_PLANS_CONCURRENCY = 3;
export const SR_QUEUE_JOB_SCRAPE_DEALER_PORTAL_BANDWIDTHBUILDERS_PROVIDER_INTERNET_PLANS =
  'SR_QUEUE_JOB_SCRAPE_DEALER_PORTAL_BANDWIDTHBUILDERS_PROVIDER_INTERNET_PLANS';
export const SR_QUEUE_JOB_SCRAPE_DEALER_PORTAL_BANDWIDTHBUILDERS_PROVIDER_INTERNET_PLANS_CONCURRENCY = 2;
